import { render } from "./Empty.vue?vue&type=template&id=1359ad0a"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tian/Desktop/桌面 - 谭天’s MacBook Pro/tt/work/DEV/tooda-apps/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__